/* eslint-disable global-require */
/* eslint-disable no-underscore-dangle */

import ReactDOM from 'react-dom';
import React, { Fragment } from 'react';
import { Provider } from 'react-redux';
import App from './containers/App';
import store from './store';
import { GlobalStyle } from './theme/global';

renderDesktopEPG();

/*
const __svg__ = { // eslint-disable-line
  path: 'assets/icons/!*.svg',
  name: 'sprite.svg',
};
*/

function renderDesktopEPG() {
  ReactDOM.render(
    <Provider store={store}>
      <Fragment>
        <GlobalStyle />
        <App />
      </Fragment>
    </Provider>,
    document.getElementById('epgModule')
  );
}
